import {closeDialog, openConfirmDialog, openDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {head, isNil} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {i18n} from '@dms/i18n';
import {catchUnhandledDataGridActions, DmsDataGrid, logError} from '@dms/shared';
import {DeliveryNoteDocumentPreview} from '@dms/warehouse/document-extraction';

import {pushGtmEvent} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const EXTRACTED_DELIVERY_NOTES = 'extracted-delivery-notes';

export function ExtractedDeliveryNotes() {
  const handleClose = () => {
    pushGtmEvent({
      event: 'button_click',
      event_id: 'ai_tool_dn_import_dialog_confirm_close',
    });
    closeDialog(DIALOG_ID);
  };

  const actionCallback: ActionCallback = ({rowId, actionKey}) => {
    const id = isArray(rowId) ? head(rowId) : rowId;

    match(actionKey)
      .with('redirectDetail', 'details', () => {
        if (isNil(id)) {
          return logError('id is not defined');
        }

        openDialog(
          <DeliveryNoteDocumentPreview
            messageId={id}
            onClose={() => {
              pushGtmEvent({
                event: 'button_click',
                event_id: 'ai_tool_dn_import_dialog_close',
              });
              openConfirmDialog({
                text: i18n.t('entity.documentExtraction.notifications.closeDialogConfirmation'),
                onConfirm: handleClose,
              });
            }}
          />,
          {
            id: DIALOG_ID,
            title: i18n.t('entity.documentExtraction.labels.documentPreview'),
            size: 'xLarge',
            withAdditionalFooter: true,
          }
        );
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return <DmsDataGrid gridCode={EXTRACTED_DELIVERY_NOTES} actionCallback={actionCallback} />;
}

const DIALOG_ID = 'document-extraction';
